class CartRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}

if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
}